import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../hooks/hooks';
import { selectnexusARecordTypesQueryItems } from '../../../../redux/nexus-a-record-types/selector';
import { nexusARecordTypes } from '../../../../redux/nexus-a-record-types/action';
import NexusARecordTypesComponent from '../components/nexus-a-records-types.component';
import PageLoader from '../../../../components/PageLoader';

const ManagementNexusARecordType = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const queryItems = useSelector(selectnexusARecordTypesQueryItems)
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [selectedNexusARecordTypes, setSelectedNexusARecordTypes] = useState<any>({})

    const fetchNexusARecordTypesQueryById = () => {
        dispatch(nexusARecordTypes.query({
            url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/nexus-management/nexus-a-record-types/query`,
            entity: 'nexusARecordTypes',
            jsonData: {
                Records: [
                    {
                        "Context": {},
                        "Message": {
                            "Id": parmas?.id,
                        }
                    }
                ]
            }
        })).then(() => {
            setIsQuery(true)
        })
    }

    const handleInnerFormChange: any = (event: any, field: string) => {
        setSelectedNexusARecordTypes({ ...selectedNexusARecordTypes, [field]: event });
    }

    useEffect(() => {
        if (parmas?.id > 0) {
            fetchNexusARecordTypesQueryById()
            setIsLoading(false)
        } else {
            setIsLoading(false)
        }
    }, []
    )

    useEffect(() => {
        if (isQuery) {
            setSelectedNexusARecordTypes(queryItems?.result?.items?.Message)
        }
    }, [isQuery]
    )

    const handleFormSubmit = async (event: any) => {
        event.preventDefault();
        if (parmas?.id > 0) {
            await dispatch(nexusARecordTypes.resetAction({ actionType: 'update' }))
           await dispatch(nexusARecordTypes.update({
                url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/nexus-management/nexus-a-record-types`,
                entity: 'nexusARecordTypes',
                jsonData: {
                    Records: [
                        {
                            "Context": {},
                            "Message": selectedNexusARecordTypes
                        }
                    ]
                }
            })).then(() => {
                back()
            })
        } else {
            await dispatch(nexusARecordTypes.resetAction({ actionType: 'create' }))
            await dispatch(nexusARecordTypes.create({
                url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/nexus-management/nexus-a-record-types`,
                entity: 'nexusARecordTypes',
                jsonData: {
                    Records: [
                        {
                            "Context": {},
                            "Message": selectedNexusARecordTypes
                        }
                    ]
                }
            })).then(() => {
                back()
            })
        }
    }

    const back = () => {
        navigate('/nexus/nexus-management/nexus-a-record-types')
    }

    return (
        <>
            {isLoading ? <PageLoader /> :
                <NexusARecordTypesComponent
                    handleInnerFormChange={handleInnerFormChange}
                    selectedNexusARecordTypes={selectedNexusARecordTypes}
                    back={back}
                    handleFormSubmit={handleFormSubmit}
                />
            }
        </>
    )
}

export default ManagementNexusARecordType;